import { render, staticRenderFns } from "./PmDataQueryForP.vue?vue&type=template&id=18ff26c3&"
import script from "./PmDataQueryForP.vue?vue&type=script&lang=js&"
export * from "./PmDataQueryForP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports